import data from "./guides.data.json";

export const GUIDES = data;

export const findGuide = (slug) => GUIDES.find((g) => g.slug === slug) || null;
